import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from '../APIEndPoints'
import { sitConfig } from '../config'
import { sendEventApi } from '../sendEvent'

export const MODE = 33
export const COUNTRY_CODE = '+91'
export const SCOPE = 'REQUEST'
export const GENERATE = 'generate'
export const PURPOSE = 1
export const ENTITY_TYPE = 3
export const extraInfo = '20000033535'

const getOtpRequestBody = (phoneNumber: string, mode: number, purpose: number, amount?: any) => {
  return {
    user: {
      mobile: {
        mobileNumber: phoneNumber,
        countryCode: COUNTRY_CODE,
      },
      emailAddress: '',
      entityType: ENTITY_TYPE,
    },
    scope: SCOPE,
    authenticateList: [
      {
        mode: mode ?? MODE,
        value: '',
        action: GENERATE,
      },
    ],
    purpose: purpose ?? PURPOSE,
    ...(amount !== undefined && { amount: amount }),
    extraInfo: extraInfo, //HARDCODE
  }
}

const responseParser = (data: any) => {
  return data
}

const generateOTP = (mobileNumber: string, tokens: any, options?: { mode?: number; purpose?: number, amount?: any }) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.userAuth,
    method: 'POST',
    config: sitConfig(tokens),
    body: getOtpRequestBody(mobileNumber, options?.mode, options?.purpose, options?.amount),
  }
  sendEventApi(tokens, request, {
    status: 'INITIATED',
  })
  return executeRequest(request)
    .then((data) => {
      return responseParser(data.data)
    })
    .then((response) => {
      sendEventApi(tokens, request, {
        status: 'SUCCESS',
      })
      return response
    })
    .catch((err) => {
      sendEventApi(tokens, request, {
        status: 'FAILED',
        errorDescription: err,
      })
      throw err
    })
}

export { generateOTP }
